export default "__VITE_ASSET__51d78d6c__"